import DashboardFilterSelect from "./DashboardFilterSelect";
import React, { useEffect, useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { useFormik } from "formik";
import {
  //   GetCoursesAPI,
  PhoneCourseReportAPI,
  phoneCourseReportCSV,
} from "../../api/server";
import PaginatedItems from "./pagination";
import moment from "moment";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";
import { downloadCSVBlob } from "../../common/downloadCSV";

const DashboardPhoneCourses = () => {
  const [filterLoading, setFilterLoading] = useState(false);
  const [reportData, setReportData] = useState();
  const [total, setTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [payload, setPayload] = useState({});
  const [dateFilter, setDateFilter] = useState("3Month");
  const [courseFilter, setCourseFilter] = useState("CC&DE"); // default no course selected
  const [csvLoading, setCsvLoading] = useState(false);
  const [courses, setCourses] = useState([]);

  const validate = (values) => {
    const errors = {};
    if (dateFilter === "Date") {
      if (!values.startDate) {
        errors.startDate = "Start date is required";
      }
      if (!values.endDate) {
        errors.endDate = "End date is required";
      } else if (values.startDate && values.endDate < values.startDate) {
        errors.endDate = "End date must be greater than start date";
      }
    }
    return errors;
  };

  const {
    handleChange,
    touched,
    values,
    errors,
    handleSubmit,
    handleBlur,
    setErrors,
    setFieldValue,
  } = useFormik({
    initialValues: {
      startDate: "",
      endDate: "",
    },
    validate,
    onSubmit: (values) => {
      fetchData(values, dateFilter, courseFilter);
    },
  });

  const fetchData = async (values, range, course, page) => {
    try {
      setFilterLoading(true);

      let params = {};
      if (range === "Date") {
        params = { ...values, range, "filter": course };
      } else {
        params = { range, startDate: "", endDate: "", "filter": course };
      }

      const res = await PhoneCourseReportAPI(page || pageNo, params);
      setReportData(res?.data?.data);
      setTotal(res?.data?.data?.total || 0);
      setPayload(params);
      if (page) setPageNo(page);
    } catch (err) {
      console.error("Error fetching Phone Course Report:", err);
    } finally {
      setFilterLoading(false);
    }
  };

  useEffect(() => {
    fetchData({}, "3Month", "CC&DE");
  }, []);

  //   useEffect(() => {
  //     const fetchCourses = async () => {
  //       try {
  //         const res = await GetCoursesAPI();
  //         setCourses(res?.data?.data?.result || []);
  //       } catch (err) {
  //         console.error("Error fetching courses:", err);
  //       }
  //     };
  //     fetchCourses();
  //   }, []);

  const handlePageChange = (newPage) => {
    fetchData(payload, dateFilter, courseFilter, newPage);
  };

  const downloadCSV = async (values) => {
    let params;
    if (dateFilter === "Date") {
      params = { ...values, range: dateFilter, "filter": courseFilter };
    } else {
      params = {
        ...values,
        range: dateFilter,
        startDate: "",
        endDate: "",
        "filter": courseFilter,
      };
    }

    setCsvLoading(true);
    try {
      const res = await phoneCourseReportCSV(params);
      downloadCSVBlob(res.data, `Phone-Courses-${dateFilter}-${courseFilter}.csv`);
    } catch (err) {
      console.error("CSV Download Error:", err);
    } finally {
      setCsvLoading(false);
    }
  };

  return (
    <>
      <section className="manage-students language_wrap">
        {dateFilter === "Date" && (
          <div
            className={`col-lg-12 mt-4 ${errors.endDate && touched.endDate ? "mb-5" : "mb-4"
              }`}
          >

            <form
              className="row align-items-center mt-5"
              onSubmit={handleSubmit}
            >
              <h6 className="fw-bold text-center col-2 ">
                <span className="text_success">Date Range:</span>
              </h6>
              <div className="col-3">
                <div className="input_wrap" style={{ marginBottom: "0px" }}>
                  <label className="label-title">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    style={{ height: "50px", position: "relative" }}
                    name="startDate"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.startDate}
                  />
                  <p
                    className="text-danger mb-4"
                    style={{ position: "absolute" }}
                  >
                    {errors.startDate && touched.startDate
                      ? errors.startDate
                      : ""}
                  </p>
                </div>
              </div>
              <div className="col-2 d-flex align-items-center justify-content-center">
                <label className="label-title">To</label>
              </div>
              <div className="col-3">
                <div className="input_wrap" style={{ marginBottom: "0px" }}>
                  <label className="label-title">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    style={{ height: "50px", position: "relative" }}
                    name="endDate"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.endDate}
                  />
                  <p
                    className="text-danger mb-4"
                    style={{ position: "absolute" }}
                  >
                    {errors.endDate && touched.endDate
                      ? errors.endDate
                      : ""}
                  </p>
                </div>
              </div>
              <div className="text-center col-2 ">
                <button
                  className="btn_brnd"
                  type="submit"
                  disabled={filterLoading}
                >
                  {filterLoading ? (
                    <ThreeDots
                      height="20"
                      width="60"
                      color="#4fa94d"
                      ariaLabel="loading"
                      visible={true}
                    />
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </form>

          </div>
        )}

        <div className="">
          <div className="">
            <div className="d-flex justify-content-between align-items-center admin-dashboard-report-toolbar">
              <h3
                style={{
                  fontWeight: "bold",
                  fontSize: "22px",
                  textTransform: "capitalize",
                }}
              >
                Phone Course Report
              </h3>
              <div className="d-flex justify-content-between align-items-center dasboard">
                {/* Export Button */}
                <button
                  className="btn_brnd"
                  style={{ padding: "6px 30px", fontWeight: "500" }}
                  type="button"
                  disabled={csvLoading}
                  onClick={() => {
                    downloadCSV(values);
                  }}
                >
                  {csvLoading ? (
                    <ThreeDots
                      height="20"
                      width="94"
                      radius="9"
                      color="#4fa94d"
                      ariaLabel="three-dots-loading"
                      visible={true}
                    />
                  ) : (
                    "Export Data"
                  )}
                </button>

                {/* Date filter dropdown */}
                <DashboardFilterSelect
                  className="form-select ms-4"
                  style={{ width: "150px" }}
                  value={dateFilter}
                  onChange={(e) => {
                    setDateFilter(e.target.value);
                    setPageNo(1);
                    if (e.target.value !== "Date") {
                      fetchData(values, e.target.value, courseFilter, 1);
                    } else {
                      setFieldValue("startDate", "");
                      setFieldValue("endDate", "");
                    }
                  }}
                >
                  <option value="Today">Today</option>
                  <option value="Week">Week</option>
                  <option value="Month">Month</option>
                  <option value="3Month">3 Month</option>
                  <option value="Date">Custom Range</option>
                </DashboardFilterSelect>

                {/* Course filter dropdown */}

                <DashboardFilterSelect
                  className="form-select ms-4"
                  style={{ width: "150px" }}
                  value={courseFilter}
                  onChange={(e) => {
                    setCourseFilter(e.target.value);
                    setPageNo(1);

                    if (
                      dateFilter === "Date" &&
                      (!values.startDate || !values.endDate)
                    ) {
                      setErrors({
                        startDate: "Start date is required",
                        endDate: "End date is required",
                      });
                    } else {
                      fetchData(values, dateFilter, e.target.value, 1);
                    }
                  }}
                  onBlur={handleBlur}
                  name="course"
                >
                  <option value="CC&DE">CC & DE</option>
                  <option value="CC">CC</option>
                  <option value="DE">DE</option>
                  {/* <option value="CC!DE">CC But Not DE</option>
                      <option value="DE!CC">DE But Not CC</option> */}
                </DashboardFilterSelect>
              </div>
            </div>

            {/* Table */}
            <div className="admin-dashboard-table-scroll">
              <table className="table admin-dashboard-table admin-dashboard-phone-table">
                <colgroup><col style={{ width: "20%" }} /><col style={{ width: "17%" }} /><col style={{ width: "12%" }} /><col style={{ width: "25%" }} /><col style={{ width: "18%" }} /><col style={{ width: "8%" }} /></colgroup>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Course</th>
                    <th>Address</th>
                    <th>Created</th>
                    <th className="admin-dashboard-view-cell">View</th>
                  </tr>
                </thead>
                <tbody>
                  {filterLoading ? (
                    <tr>
                      <td
                        colSpan="6"
                        style={{ textAlign: "center", height: "100px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                          }}
                        >
                          <ThreeDots
                            height="40"
                            width="80"
                            color="#4fa94d"
                            ariaLabel="loading"
                            visible={true}
                          />
                        </div>
                      </td>
                    </tr>
                  ) : reportData && reportData?.result?.length > 0 ? (
                    reportData.result.map((item, index) => (
                      <tr key={index}>
                        <td>{item?.name || "N/A"}</td>
                        <td>{item?.phone || "N/A"}</td>
                        <td>{item?.course || "N/A"}</td>
                        <td>{item?.address?.trim() ? item.address : "N/A"}</td>
                        <td>
                          {item?.created_at
                            ? moment(item.created_at).format("MMMM Do YYYY")
                            : "N/A"}
                        </td>
                        <td className="admin-dashboard-view-cell">
                          <Link className="admin-dashboard-view-link" to={`/editstudent?id=${item.id}`}
                            aria-label={`View ${item?.name || "student"}`}>
                            <FaEye aria-hidden="true" />
                          </Link>

                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: "center" }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {!filterLoading && total > 10 && (
              <PaginatedItems responsive
                total={total}
                pageNo={pageNo}
                setPageNo={setPageNo}
                pageSize={10}
                handlePageChangeInCompletionForm={handlePageChange}
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default DashboardPhoneCourses;
